export const FitterNameDisplayContext = {
  SlotListDefault: 'slotListDefault',
  SlotListOnlyMobility: 'slotListOnlyMobility',
  MapFitterCard: 'mapFitterCard',
  DialogSelectApmt: 'dialogSelectApmt',
  FitterCommentsPage: 'fitterCommentsPage',
  DossierFixedSummary: 'dossierFixedSummary',
  CalendarExport: 'calendarExport',
  SettingsHeader: 'settingsHeader',
  BasketItemHeader: 'basketItemHeader',
  FitterPopupHeader: 'fitterPopupHeader',
  TagManager: 'tagManager',
  NotifCenter: 'notifCenter',
} as const;
export type FitterNameDisplayContext =
  typeof FitterNameDisplayContext[keyof typeof FitterNameDisplayContext];

export const FitterNameDisplayDefaultKeys = {
  ClientAppDefaultValue: 'shared',
  ContextualDefaultValue: 'default',
  BrandDefaultValue: 'brandless',
} as const;
export type FitterNameDisplayDefaultKeys =
  typeof FitterNameDisplayDefaultKeys[keyof typeof FitterNameDisplayDefaultKeys];
